import { getCmsProperty } from '@sunrise/shared'
import { Cms } from '@sunrise/types'
import { CmsPropertyKeys } from '../../cmsElements/M/M_AMS_Resultlist/M_AMS_Resultlist.interface'

export const slotNameforPosition = (position: number, breakpoint: 'desktop' | 'mobile') =>
    `disturber-${position}-${breakpoint}`

export const slotNameForDisturber = (cmsContent: Cms.Content) => {
    const cmsPosition = getCmsProperty<number>(CmsPropertyKeys.ResultlistDisturberPosition, cmsContent)
    const cmsBreakpoint = getCmsProperty<'desktop' | 'mobile'>(
        CmsPropertyKeys.ResultlistDisturberBreakpoint,
        cmsContent,
    )

    if (typeof cmsPosition !== 'number' || !cmsBreakpoint) {
        return 'no-slot'
    }

    const zeroBasedPosition = cmsPosition - 1

    return slotNameforPosition(zeroBasedPosition, cmsBreakpoint)
}
